import { useAutoUpdate } from 'app-context/auto-update/AutoUpdate';
import { useTour } from 'app-context/tourContext/TourContext';
import TourModal from 'component/hoc/tour-modal/TourModal';
import VoiceRecordingTemplate from 'component/organism/voice-recording/VoiceRecordingTemplate';
import { voiceToast } from 'helpers/toastMessages';
import { companyEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { usePost } from 'hooks/usePost';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';

const VoiceRecording = () => {
  const { toggleAutoUpdate } = useAutoUpdate();

  const ref = useRef(null);
  const { id } = useParams();
  const { showModal } = useTour();
  const { mutate: saveTerms, isPending } = usePost({
    onSuccessToast: voiceToast.save,
    toastType: 'add',
  });
  const { data, isFetching, refetch } = useFetch(
    ['voiceRecording', id],
    companyEndpoints.getChatSettings,
    { enabled: true },
    { botId: id }
  );

  const handleSave = async () => {
    await ref.current.submitForm();
    const formIsValid = ref.current?.isValid;
    if (formIsValid) {
      saveTerms(
        {
          url: companyEndpoints.setCompanyChatSettings(),
          data: {
            ...ref?.current?.values,
            botId: id,
          },
        },
        {
          onSuccess: () => {
            refetch();
            toggleAutoUpdate();
          },
        }
      );
    }
  };
  return (
    <>
      <SettingsHeader
        title='Voice'
        rightButtons={[
          {
            label: 'Save',
            type: 'save',
            func: handleSave,
            isLoading: isPending,
          },
        ]}
      />
      <VoiceRecordingTemplate
        ref={ref}
        id={id}
        data={data}
        isFetching={isFetching}
      />
      {showModal && <TourModal />}
    </>
  );
};

export default VoiceRecording;
